import { EnvKeys, IConfigStore } from '../models/stores/config.models';

export class ConfigStore implements IConfigStore {

  public readonly builderAPI: string;
  public readonly assessorApi: string;
  public readonly localToken: string | undefined;
  public readonly localS3Token: string | undefined;
  public readonly yandexMetrikaId: string | undefined;
  public readonly bucketAPI: string;

  constructor() {
    this.assessorApi = this.getRequired(EnvKeys.assessorApi);
    this.builderAPI = this.getRequired(EnvKeys.builderAPI);
    this.bucketAPI = this.getRequired(EnvKeys.bucketAPI);

    this.localToken = this.getValue(EnvKeys.localToken);
    this.localS3Token = this.getValue(EnvKeys.localS3Token);
    this.yandexMetrikaId = this.getValue(EnvKeys.yandexMetrikaId);
  }

  private getValue(key: EnvKeys): string | undefined {
    const value = process.env[key];
    return value;
  }

  private getRequired(key: EnvKeys): string {
    const value = this.getValue(key);
    if (typeof value !== 'string' || value.length === 0) {
      throw new Error(`Cannot find "${key}" parameter from environment`);
    }
    return value;
  }

}
